'use strict';

import { GLOBAL } from './Global';
import { SENDER as SENDER_PERMISSION_GROUPS } from '../PermissionsGroups';

const sender_permissions_list = [];

for (const [key, value] of Object.entries(SENDER_PERMISSION_GROUPS)) {
  sender_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SENDER = {
  can: [
    ...GLOBAL.can,
    ...sender_permissions_list,
  ],
};

export {
  SENDER,
};
